import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import {
  landingSectionButton,
  buttonContainer,
} from './scss/LandingSection.module.scss';

const LandingSectionButton = ({ children, href, className }) => {
  return (
    <div className={classNames(buttonContainer, className)}>
      <Link to={href} className={landingSectionButton}>
        {children}
      </Link>
    </div>
  );
};

LandingSectionButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

LandingSectionButton.defaultProps = {
  className: '',
};

export default LandingSectionButton;
